import React from "react";
import styles from "./BarChart.scss";
import cx from "../../utils/cx";
import { IFinancialCheckData } from "./FinancialCheckPage";
import Translate from "../../utils/Translate";

export interface IBarChartProps {
  className?: string;
  loanData: IFinancialCheckData['loanData'];
}

const BarChart: React.FC<IBarChartProps> = ({ className = '', loanData }) => {

  if (!loanData?.price) return null;

  const total = loanData?.price + loanData?.closingCosts;

  return <div className={cx(styles.barChart, className)}>

    <div className={styles.price}>
      <div className={styles.details}>
        <span>
          Kaufpreis
        </span>
        <span>
          {Translate.getNumber(loanData?.price)} €
        </span>
      </div>
      <div className={styles.bar}>
        <span style={{ width: `${Math.min(100, loanData.price / total * 100)}%` }}></span>
      </div>
    </div>
    <div className={styles.closingCosts}>
      <div className={styles.details}>
        <span>
          Kaufnebenkosten
        </span>
        <span>
          {Translate.getNumber(loanData?.closingCosts)} €
        </span>
      </div>
      <div className={styles.bar}>
        <span style={{ width: `${Math.min(100, loanData.closingCosts / total * 100)}%` }}></span>
      </div>
    </div>
    <div className={styles.equity}>
      <div className={styles.details}>
        <span>
          Eigenkapital
        </span>
        <span>
          {Translate.getNumber(loanData?.equity)} €
        </span>
      </div>
      <div className={styles.bar}>
        <span style={{ width: `${Math.min(100, loanData.equity / total * 100)}%` }}></span>
      </div>
    </div>
    <div className={styles.loan}>
      <div className={styles.details}>
        <span>
          Finanzierung
        </span>
        <span>
          {Translate.getNumber(loanData?.loan)} €
        </span>
      </div>
      <div className={styles.bar}>
        <span style={{ width: `${Math.min(100, loanData.loan / total * 100)}%` }}></span>
      </div>
    </div>






  </div>
};

export default BarChart;
